import type { BrandConfig } from './BrandConfig.interface';

export const defaultBrandConfig: Partial<BrandConfig> = {
  id: '1210',
  code: 'rc',
  name: 'RingCentral',
  appName: 'RingCentral Widgets',
  application: 'RingCentral Widgets',
};
